// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__bBMZs","checkbox_placeholder":"Checkbox_checkbox_placeholder__VZMl0","checkbox_selected":"Checkbox_checkbox_selected__NAswc"};